import { cn } from "@/lib/utils";
import { BREAKPOINTS } from "@/settings";
import { useSelector } from "react-redux";
import { useMediaQuery } from "usehooks-ts";

import { shouldShowAdsSelector } from "../redux/user/userSlice";

export const SimpleAdUnit = () => {
  const shouldShowAds = useSelector(shouldShowAdsSelector);
  if (!shouldShowAds) return null;
  return <div id="pubnation-ad" />;
};

export const LeaderboardAdUnit = () => {
  const shouldShowAds = useSelector(shouldShowAdsSelector);
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE.query);
  if (!shouldShowAds) return null;
  if (isMobile)
    return (
      <div className="h-17">
        <div className="mv_slot_target" data-slot="LeaderboardMobile" />
      </div>
    );
  return <div id="pubnation-leaderboard" className="min-h-22.5" />;
};
